export default "__VITE_ASSET__C_ItnB7b__"